export default [
  { productId: 'os10_1_usuario_mensal', nome: '1 usuário 300 O.S./mês' },
  { productId: 'os10_3_usuarios_mensal', nome: '3 usuários 600 O.S./mês' },
  { productId: 'os10_6_usuarios_mensal', nome: '6 usuários 1200 O.S./mês' },
  { productId: 'os10_1_usuario_trimestral', nome: '1 usuário 300 O.S./mês' },
  { productId: 'os10_3_usuarios_trimestral', nome: '3 usuários 600 O.S./mês' },
  { productId: 'os10_6_usuarios_trimestral', nome: '6 usuários 1200 O.S./mês' },
  { productId: 'os10_1_usuario_semestral', nome: '1 usuário 300 O.S./mês' },
  { productId: 'os10_3_usuarios_semestral', nome: '3 usuários 600 O.S./mês' },
  { productId: 'os10_6_usuarios_semestral', nome: '6 usuários 1200 O.S./mês' },
  { productId: 'os10_1_usuario_anual', nome: '1 usuário 300 O.S./mês' },
  { productId: 'os10_3_usuarios_anual', nome: '3 usuários 600 O.S./mês' },
  { productId: 'os10_6_usuarios_anual', nome: '6 usuários 1200 O.S./mês' },
  { productId: 'os10_30_usuarios_mensal', nome: '30 usuários 9000 O.S./mês' },
  { productId: '', nome: '' },
];
